<template>
  <!-- <div class="mt-30neg md:pl-8" @click="handleClick('e-cart')"> -->
  <div class="mt-30neg md:pl-8">
    <b-card
      class="p-2 border-b4b4b4"
      v-for="(item, index) in course"
      :key="index"
    >
      <!-- <img
        src="@/assets/images/courses/6.png"
        alt="img"
        class="img-h243px object-cover rounded-lg"
      /> -->
      <img
        :src="`${$imageURL}/${item.icone}`"
        alt="img"
        class="img-h243px object-contain rounded-lg w-full"
      />
      <div
        class="amount p-4 flex items-center md:px-12 justify-center"
        v-if="item.price < 1"
      >
        <p class="fsize1-5 font-bold">Free</p>
      </div>
      <div class="flex mt-2 lg:flex-wrap" v-else>
        <div
          class="amount p-4 flex md:flex-wrap items-center xl:px-12"
          v-if="item.price != item.discountPrice"
        >
          <template
            v-if="
              Object.keys(getUserByUserId).length !== 0 &&
              Object.hasOwn(getUserByUserId, 'currentMembership')
            "
          >
            <div class="flex items-center gap-2">
              <del class="fsize14">Rs. {{ item.price }}</del>
              <h4 class="fsize18 font-bold">
                Rs.
                {{
                  (
                    item.discountPrice -
                    (getUserByUserId.currentMembership.discount / 100) *
                      item.discountPrice
                  ).toFixed(2)
                }}
              </h4>
            </div>
            <h6 class="fsize1-1 font-bold">
              <span class="fsize14">
                {{
                  (
                    ((item.price - item.discountPrice) / item.price) *
                    100
                  ).toFixed(2)
                }}% off +
              </span>
              <br />
              <span class="text-success fsize14">
                {{ getUserByUserId.currentMembership.discount.toFixed(2) }}%
                Membership Discount
              </span>
            </h6>
          </template>
          <template v-else>
            <h4 class="fsize1-5 font-bold">Rs. {{ item.discountPrice }}</h4>
            <del class="fsize1-1 px-4">Rs. {{ item.price }}</del>
            <h6 class="fsize1-1 font-bold">
              {{
                (
                  ((item.price - item.discountPrice) / item.price) *
                  100
                ).toFixed(2)
              }}% off
            </h6>
          </template>
        </div>
        <div
          class="amount p-4 flex items-center md:px-12 justify-center"
          v-else
        >
          <template
            v-if="
              Object.keys(getUserByUserId).length !== 0 &&
              Object.hasOwn(getUserByUserId, 'currentMembership')
            "
          >
            <h4 class="fsize1-5 font-bold">
              Rs.
              {{
                (
                  item.price -
                  (getUserByUserId.currentMembership.discount / 100) *
                    item.price
                ).toFixed(2)
              }}
            </h4>
            <del class="fsize1-1 px-4">Rs. {{ item.price }}</del>
            <h6 class="fsize1-1 font-bold">
              {{ getUserByUserId.currentMembership.discount.toFixed(2) }}% off
            </h6>
          </template>
          <template v-else>
            <h4 class="fsize1-5 font-bold">Rs. {{ item.price }}</h4>
          </template>
          <!-- <h4 class="fsize1-5 font-bold">Rs. {{ item.price }}</h4> -->
        </div>
      </div>
      <!-- <div class="mt-2" v-if="cartData.length < 1">
        <base-button
          class="w-full mb-3 font-normal py-4 text-xl"
          type="primary"
          v-if="userData.role != 'admin' && userData.role != 'author'"
          @click="addToCart('check-cart', item)"
          >Add to Cart</base-button
        >
       
      </div>
      <div class="mt-2" v-if="cartData.length > 0">
        <base-button
          class="w-full mb-3 font-normal py-4 text-xl"
          type="primary"
          v-if="userData.role != 'admin' && userData.role != 'author'"
          @click="addToCart('check-cart', item)"
          >Go to Cart</base-button
        >
     
      </div> -->

      <div
        class="mt-2"
        v-if="
          userData.hasOwnProperty('student') &&
          item.attendees.includes(userData.student._id)
        "
      >
        <base-button
          class="w-full mb-3 font-normal py-2 fsize16"
          type="primary"
          v-if="userData.role != 'admin' && userData.role != 'author'"
          :disabled="userData.role == 'vendor'"
          @click="goToCart('e-my-learning')"
          >Go to Course</base-button
        >
      </div>
      <div class="mt-2" v-else-if="item.price < 1">
        <base-button
          class="w-full mb-3 font-normal py-2 fsize16"
          type="primary"
          v-if="userData.role != 'admin' && userData.role != 'author'"
          :disabled="userData.role == 'vendor'"
          @click="addToCart('check-cart', item)"
          >Enroll Course</base-button
        >
      </div>
      <div class="mt-2 flex justify-center" v-else>
        <template v-if="courseId.includes(item._id)">
          <base-button
            class="mb-3 font-normal py-2 fsize16"
            type="primary"
            v-if="userData.role != 'admin' && userData.role != 'author'"
            :disabled="userData.role == 'vendor'"
            @click="goToCart('e-my-learning')"
            >Go to Course</base-button
          >
        </template>
        <template v-else>
          <base-button
            class="mb-3 font-normal py-2 fsize16"
            type="primary"
            v-if="userData.role != 'admin' && userData.role != 'author'"
            :disabled="userData.role == 'vendor'"
            @click="addToCart('check-cart', item)"
          >
            Add to Cart
          </base-button>
        </template>
      </div>

      <!-- <p class="mt-3 lg:text-xl md:text-xl text-lg font-normal text-center">
        30-Day Money-Back Guarantee
      </p> -->

      <div class="text-center mt-2">
        <h2 class="font-bold mb-4 lg:text-xl md:text-xl text-lg text-black">
          This course includes
        </h2>
        <!-- <p class="mt-2 lg:text-xl md:text-xl text-lg font-normal text-center">
          15 hours on-demand video
        </p>
        <p class="mt-2 lg:text-xl md:text-xl text-lg font-normal text-center">
          18 downloadable resources
        </p> -->
        <p class="mt-2 fsize14 font-normal text-center">Full lifetime access</p>
        <p class="mt-2 fsize14 font-normal text-center">
          Access on {{ item.platform.toString() }}
        </p>
        <p class="mt-2 fsize14 font-normal text-center">
          Certificate of Completion
        </p>
      </div>
    </b-card>

    <CourseOverview />
    <Recommendedcard />
  </div>
</template>
<script>
import CourseOverview from "./CourseOverview";
import Recommendedcard from "./Recommendedcard";
import { mapState } from "vuex";

export default {
  data() {
    return {
      // key: value,
      course: [],
      cartData: [],
      courses: [],
      courseId: [],
    };
  },

  components: {
    CourseOverview,
    Recommendedcard,
  },
  methods: {
    selectedCourse() {
      this.course.push(this.selectedCourseHome);
    },
    async getAllCart() {
      const { data } = await this.$store.dispatch("cart/getCartData", {
        userId: this.userData._id,
      });
      data.map((data) => this.cartData.push(data.course.toString()));
      // console.log(data);
      // console.log(a, this.studentLearning[0]._id, this.userData._id);
    },

    async addToCart(name, item) {
      const token = sessionStorage.getItem("token");
      if (token == "" || token == undefined || token == null) {
        return this.$router.push("/sign-in");
      }
      let flag = 0;

      this.cartData.filter((data) => {
        if (data == item._id) {
          flag = 1;
        }
      });
      if (flag == 1) {
        // this.$swal.fire({
        //   title: "Already added",
        //   text: "Please check the cart!",
        //   icon: "warning",
        //   showConfirmButton: false,
        //   showCancelButton: false,
        //   timer: 2000,
        // });
        this.$notify({
          title: "Already Exist",
          message: "Course already in cart!!",
          type: "info",
          duration: "2000",
        });
        this.$router.push({ name: "e-cart" });
      } else {
        const data = await this.$store.dispatch("cart/AddCart", {
          type: "Course",
          course: item._id,
        });
        // console.log(data);
        try {
          if (data.code == 200) {
            this.$store.commit("auth/userCart", data.data);
            // this.$swal.fire({
            //   title: "Added To Cart!!!",

            //   text: "Course added to your learning plan!",

            //   icon: "success",
            //   showConfirmButton: false,
            //   showCancelButton: false,
            //   timer: 2000,
            // });
            this.$notify({
              title: "Added",
              message: "Course added cart!",
              type: "success",
              duration: "2000",
            });

            this.cartData.push(item._id);
            this.$router.push({ name: "e-cart" });
          } else if (err.response.code == 400()) {
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Your session has ended and for security reasons, we request you to login again",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        } catch (err) {
          // console.log(err.response);
          if (err.response.code == 400) {
            this.$router.push({ name: "signin" });
            this.$swal.fire({
              title: "Session Expired",
              text: "Your session has ended and for security reasons, we request you to login again",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
      }
    },

    async goToCart(name, item) {
      this.$router.push({ name: "e-my-learning" });
    },
  },
  async mounted() {
    if (Object.keys(this.user).length != 0) {
      let payload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        payload
      );
    }
    this.studentLearning.length &&
      this.studentLearning[0].course.forEach((ele) =>
        this.courseId.push(ele._id)
      );
    // console.log(this.courseId, "**********");
    this.selectedCourse();
    this.getAllCart();
    // console.log(this.selectedCourseHome);
  },
  computed: {
    // ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("eLearning", ["selectedCourseHome"]),
    ...mapState("auth", ["userData", "user", "getUserByUserId"]),
    ...mapState("cart", ["getCart"]),
    ...mapState("student", ["studentLearning"]),
  },
};
</script>
